import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Button extends Controller {

    constructor(dom, options) {
        super(dom, "Button");

        if (options) {
            if (options.formlisten)
                this.formlisten = true;

            if (options.uri)
                this.uri = options.uri;
        }
    }
    /*
    * create server listener from usual button
    */
    serverListener(key) {
        let that = this,
            form = this.domNode,
            isFindForm = false;

        if (this.formlisten) {
            while(form && form!=document.body) {
                if (form.tagName.toLowerCase()=="form") {
                    isFindForm = true;
                    break;
                }
                form = form.parentNode;
            }
        }

        function _sendRequestToServer(form) {
            Engine.postRequest(
                that.uri ? that.uri+"ajax-"+key : "ajax-"+key,
                Engine.getPagesFieldsValue(form) ,
                function (response) {
                    try {
                        var response = JSON.parse(response);
                    }catch (e) {
                        new Notice("500: Error request","error");
                        console.log (response);
                        return;
                    }

                    if (response.result=="success") {
                        new Notice(String(response.message));

                        if (response.message == 'Мероприятие создано') {
                            localStorage.setItem('eventAdded', true);
                        }

                        if (response.reload)
                            setTimeout(function () {
                                location.reload();
                            
                            },1000);

                        if (response.redirect) {
                            setTimeout(function () {
                                location.href = response.redirect;
                            },1000);
                        }
                           
                    }
                    else {
                        new Notice("Error: "+response.message,"error");

                        if (response.reload)
                            setTimeout(function () {
                                location.reload();
                            },1000);

                        if (response.redirect)
                            setTimeout(function () {
                                location.href = response.redirect;
                            },1000);
                    }

                }
            );
        }

        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            if (that.formlisten && isFindForm) {

                if (that.formListener)
                    that.formListener.disconnect();

                //its mean what form valid
                that.formListener = cfJS.addListener(form, "submit", function (e) {
                    _sendRequestToServer(form);
                    e.preventDefault();
                    return false;
                });
            } else
                _sendRequestToServer();
        });
    }
    /*
    * call client trigger by listener
    */
    clientListener(key) {
        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            window[key](e);
        });
    }
    /*
    * call link event click
    */
    clientLinkListener(url) {
        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            location.href = url;
        });
    }
}

window.Button = Button;